// Генератор паролей для форм создания сотрудников (CPAYMENT-1625).
// Формат: 4 группы по 5 символов через дефис — hdgfU-36Gf7s-vf3yd-1bvyD.
// Источник случайности — crypto.getRandomValues, Math.random для паролей не используем.

const ALPHABET = 'abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789'
const GROUPS = 4
const GROUP_LENGTH = 5

export const generatePassword = (): string => {
  const bytes = new Uint32Array(GROUPS * GROUP_LENGTH)
  crypto.getRandomValues(bytes)

  const chars = Array.from(bytes, (byte) => ALPHABET[byte % ALPHABET.length])

  return Array.from({length: GROUPS}, (_, group) =>
    chars.slice(group * GROUP_LENGTH, (group + 1) * GROUP_LENGTH).join('')
  ).join('-')
}
